exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apollo-layout-content{margin-left:0;min-height:calc(100vh - 70px);min-width:75pc;width:75pc;margin:auto}.ScrollbarsCustom .wrapper{margin:0!important}.ScrollbarsCustom .track{background:transparent!important}.ScrollbarsCustom .thumb{background:rgba(0,0,0,.3)!important;border-radius:5px!important}.ScrollbarsCustom .track.trackY{width:9px}.ScrollbarsCustom .track.trackX{height:9px}.ScrollbarsCustom>.track{opacity:0;transition:opacity .2s}.ScrollbarsCustom:hover>.track{opacity:1}.prefix__cls-1,.prefix__cls-2{fill:currentColor}.prefix__cls-2{fill-rule:evenodd}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/containers/App/components/Layout/style.css
 ** module id = 1692
 ** module chunks = 0
 **/